import useYesObject from 'modules/shared/hooks/useYesObject'
import { Interaction } from 'types/shared'

type UseInteractionModelParams = {
  interactionUuid?: string
  enabled?: boolean
}

const useInteraction = ({
  interactionUuid,
  enabled
}: UseInteractionModelParams) => {
  return useYesObject<Interaction>({
    objectUUID: interactionUuid,
    objectclassUUID: window.interactionObjectclassUuid,
    objectSituation: [window.draftSituationCode, window.activeSituationCode],
    displayMessageOnNoItemsFound: false,
    enabled
  })
}

export default useInteraction
